import { LinkButton } from "~/common/components/Link";
import { Card, Stack, styled, Typography } from "~/common/mui";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import {
  C_ON_SURFACE_LOW_EMPHASIS,
  C_OUTLINE_VARIANT,
  C_SURFACE_CONTAINER_HIGH,
  C_SURFACE_CONTAINER_HIGHEST,
} from "~/common/components/icon/Colors";
import { useTranslation } from "react-i18next";

interface UploadSectionProps {
  disabled: boolean;
  isDragging: boolean;
  selectFile: () => void;
  fileFormatText?: string;
}

export const FileUploadArea = ({ disabled, selectFile, fileFormatText }: UploadSectionProps) => {
  const { t } = useTranslation();

  return (
    <UploadCard>
      <UploadContent>
        <CloudIcon />
        <Stack gap={1}>
          <Typography variant="labelLarge">
            <LinkButton disabled={disabled} onClick={selectFile}>
              {t("quoteSplit.uploadDialog.selectFile")}
            </LinkButton>
            &nbsp;
            {t("quoteSplit.uploadDialog.selectFileOr")}
          </Typography>
          <Typography variant="bodySmall">{fileFormatText}</Typography>
        </Stack>
      </UploadContent>
    </UploadCard>
  );
};

const UploadCard = styled(Card)({
  display: "flex",
  height: "136px",
  padding: "32px 0",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "16px",
  alignSelf: "stretch",
  backgroundColor: C_SURFACE_CONTAINER_HIGH,
  border: `1px dashed ${C_OUTLINE_VARIANT}`,
  borderRadius: "16px",
  "&:hover": {
    backgroundColor: C_SURFACE_CONTAINER_HIGHEST,
  },
});

const UploadContent = styled(Stack)({
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: "24px",
});

const CloudIcon = styled(CloudUploadOutlinedIcon)({
  width: "72px",
  height: "72px",
  color: C_ON_SURFACE_LOW_EMPHASIS,
});
